import { render, staticRenderFns } from "./GenericStatusWidget.vue?vue&type=template&id=69754fc0&scoped=true&"
import script from "./GenericStatusWidget.vue?vue&type=script&lang=js&"
export * from "./GenericStatusWidget.vue?vue&type=script&lang=js&"
import style0 from "./GenericStatusWidget.vue?vue&type=style&index=0&id=69754fc0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69754fc0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pro-tekt/protekt_webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('69754fc0')) {
      api.createRecord('69754fc0', component.options)
    } else {
      api.reload('69754fc0', component.options)
    }
    module.hot.accept("./GenericStatusWidget.vue?vue&type=template&id=69754fc0&scoped=true&", function () {
      api.rerender('69754fc0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/device/device_status_widgets/GenericStatusWidget.vue"
export default component.exports